export const styles = {
  root: {
    overflow: 'hidden',
  },
  wrapper: {
    overflowY: 'scroll',
    padding: '20px 20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100svh',
  },
  container: {
    height: '100%',
    width: '100%',
    maxWidth: '580px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
